import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useMyContext } from '../provider/MyProvider'
import { fadeIn, fadeOut, slideDown, slideUp } from '../../js/animation'
import { ModalHeader } from '../product/ProductModal'
import { imgURL } from '../Footer'
import { postUserNotiSetting } from '../../api/login'
import { getFormattedDate } from '../../js/script'

/**
 * 모달 팝업 - 섬 모양
 *
 * @params content - 콘텐츠 내용
 */

export default function MarketingGiveUpModal({
  setMarketingGiveUpModal,
  setCheckedAgree,
}: {
  setMarketingGiveUpModal: React.Dispatch<React.SetStateAction<boolean>>
  setCheckedAgree: React.Dispatch<React.SetStateAction<boolean>>
}) {
  const { setToastMessage, setIsToast } = useMyContext()
  const [closing, setClosing] = useState<boolean>(false) // 닫힘 애니메이션 적용에 필요

  const closeModal = () => {
    setClosing(true)

    setTimeout(() => {
      setMarketingGiveUpModal(false)
      setClosing(false)
    }, 280)
  }

  const handleGiveUp = async (e: React.MouseEvent) => {
    e.preventDefault() // 이벤트 기본 동작 방지

    try {
      setIsToast(true)
      setToastMessage(`마케팅 알림 수신 ${getFormattedDate()} 에 동의 거부 처리 되었습니다.`)
      await postUserNotiSetting(false)
      setCheckedAgree((prev: boolean) => {
        return !prev
      })
      closeModal()
    } catch (err) {
      console.error(err)
    }
  }

  const handleKeep = async (e: React.MouseEvent) => {
    e.preventDefault() // 이벤트 기본 동작 방지

    try {
      setIsToast(true)
      setToastMessage(`마케팅 알림 수신 ${getFormattedDate()} 에 동의 완료 처리 되었습니다.`)
      await postUserNotiSetting(true)
      closeModal()
      setCheckedAgree((prev: boolean) => {
        return !prev
      })
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return (
    <ModalWrap>
      <ModalBox closing={closing} style={{ gap: '0', borderRadius: '24px', paddingBottom: '50px', maxWidth: '337px' }}>
        <ModalHeader style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button className='btn_close' onClick={closeModal}>
            <img src={`${imgURL}/icon_close.png`} alt='닫기' />
          </button>
        </ModalHeader>
        <ModalBody>
          <div className='welcome_giveup_wrap'>
            <div className='welcome_giveup_contents' style={{ padding: '8px 0px 30px 0px' }}>
              <h3 style={{ fontSize: '28px', lineHeight: '34px', fontWeight: '400', marginBottom: '30px' }}>
                마케팅 알림 해지 시
                <br />
                보상이 중단됩니다.
              </h3>
              <p className='sub_txt'>
                수신동의를 유지하시면 5일마다 적립금 1,000<br></br>원이 발급됩니다. 그래도 해제 하시겠습니까?
              </p>
            </div>
            <div className='button_area' style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
              <button
                onClick={handleGiveUp}
                style={{ borderRadius: '25px', maxWidth: '237px', backgroundColor: '#F3F3F3' }}
              >
                보상 포기하기
              </button>
              <button className='black' style={{ borderRadius: '25px', maxWidth: '237px' }} onClick={handleKeep}>
                계속 보상 받기
              </button>
            </div>
          </div>
        </ModalBody>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  )
}

interface typeProps {
  closing?: boolean
}

export const ModalBackground = styled.div<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
  z-index: 20;
`

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
`

export const ModalBox = styled.div<typeProps>`
  width: calc(100% - 40px);
  background-color: var(--colWhite);
  padding: 0 20px 20px;
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease-in-out;
  position: fixed;
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 10px;
  @media screen and (min-width: 768px) {
    width: 353px;
  }
`

export const ModalBody = styled.div``

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`
